// extracted by mini-css-extract-plugin
module.exports = {"menuBox":"HeaderLinkBox_menuBox__3x3Np","dotBox":"HeaderLinkBox_dotBox__h4Gqp","mobMenu":"HeaderLinkBox_mobMenu__6GLtr","hide":"HeaderLinkBox_hide__SJHCB"};